<template>
  <footer class="site-footer-modern">
    <div class="footer-main">
      <div class="footer-inner">
        <!-- Column 1: Brand -->
        <div class="footer-col footer-brand">
          <img :src="logo" alt="logo" class="footer-logo">
          <p class="footer-desc">{{ $t('footer_desc') || 'CAS HuaZhi - Smart watch technology solutions provider.' }}</p>
          <div class="footer-social">
            <a href="#" class="social-link">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
              </svg>
            </a>
            <a href="#" class="social-link">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zM17.5 6.5h.01" stroke="#1a1a2e" stroke-width="2" fill="none"/>
              </svg>
            </a>
            <a href="#" class="social-link">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                <path d="M23 3a10.9 10.9 0 01-3.14 1.53A4.48 4.48 0 0012 8v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- Column 2: Quick Links -->
        <div class="footer-col">
          <h4 class="footer-col-title">{{ $t('download_page.quick_links') || 'Quick Links' }}</h4>
          <ul class="footer-links">
            <li><router-link to="/">{{ $t('nav.home') }}</router-link></li>
            <li><router-link to="/products">{{ $t('nav.products') }}</router-link></li>
            <li><router-link to="/resources">{{ $t('nav.resources') }}</router-link></li>
            <li><router-link to="/leecho">{{ $t('nav.leecho') }}</router-link></li>
            <li><router-link to="/levue">{{ $t('nav.levue') }}</router-link></li>
            <li><router-link to="/lebond">{{ $t('nav.lebond') }}</router-link></li>
            <li><router-link to="/lesound">{{ $t('nav.lesound') }}</router-link></li>
            <li><router-link to="/contact">{{ $t('nav.contact') }}</router-link></li>
            <li><router-link to="/about">{{ $t('nav.about') }}</router-link></li>
            <li><router-link to="/download">{{ $t('nav.download') }}</router-link></li>
          </ul>
        </div>

        <!-- Column 3: Products -->
        <div class="footer-col">
          <h4 class="footer-col-title">{{ $t('products.title') || 'Products' }}</h4>
          <ul class="footer-links">
            <li><router-link to="/products">{{ $t('products.productList[0]') || 'Smart Watch' }}</router-link></li>
            <li><router-link to="/products">{{ $t('products.productList[1]') || 'Gearbox Watch' }}</router-link></li>
            <li><router-link to="/products">{{ $t('products.productList[2]') || 'Drum Roller Watch' }}</router-link></li>
          </ul>
        </div>

        <!-- Column 4: Contact -->
        <div class="footer-col footer-contact">
          <h4 class="footer-col-title">{{ $t('contact.title') || 'Contact Us' }}</h4>
          <div class="contact-list">
            <div class="contact-row">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
              </svg>
              <div><small>{{ primaryContact.tel.name }}</small><a :href="`tel:${primaryContact.tel.value}`">{{ primaryContact.tel.value }}</a></div>
            </div>
            <div class="contact-row">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              <div><small>{{ primaryContact.email.name }}</small><a :href="`mailto:${primaryContact.email.value}`">{{ primaryContact.email.value }}</a></div>
            </div>
            <div class="contact-row">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              <div><small>{{ primaryAddress.companyName }}</small><span>{{ primaryAddress.addr }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="footer-bottom">
      <div class="footer-bottom-inner">
        <div class="copyright">
          <strong>© 2018-2026 {{ create_by }}</strong>
          <span>{{ copyrightLabel }}</span>
        </div>
        <div class="footer-bottom-links">
          <a class="beian-link" href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">{{ beian }}</a>
          <a href="javascript:void(0);" @click="showSupport">{{ $t('footer_support') || 'Service Support' }}</a>
        </div>
      </div>
    </div>

    <!-- Support Modal -->
    <div id="myModal" :class="showModel ? 'modal show' : 'modal hide'" @click="closeSupport">
      <div class="modal-content" @click.stop="ncloseSupport">
        <span class="close" @click="closeSupport">&times;</span>
        <h3 class="modal-title">{{ $t('footer_support') || 'Service Support' }}</h3>
        <div class="modal-body">
          <p v-for="item in supportDetails" :key="item.label"><strong>{{ item.label }}：</strong>{{ item.value }}</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    logo() {
      if (window.location.href.indexOf('mltcloud.com') !== -1 || this.lang.indexOf('_ml') !== -1) {
        return require(`@/assets/images/mllogo-footer.png`);
      }
      const logoLang = this.lang.indexOf('en') !== -1 ? 'en' : 'zh';
      return require(`@/assets/images/logo-2-${logoLang}.png`);
    },
    primaryContact() {
      return this.$t('contact').items[0];
    },
    primaryAddress() {
      return this.$t('contact').address[0];
    },
    isMltBrand() {
      return window.location.href.indexOf('mltcloud.com') !== -1 || this.lang.indexOf('_ml') !== -1;
    },
    beian() {
      if (this.isMltBrand) {
        return "粤ICP备17071630号";
      }
      return '粤ICP备17071630号';
    },
    create_by() {
      if (this.isMltBrand) {
        return this.lang.indexOf('en') !== -1 ? 'Mltcloud (Shenzhen) Ltd.' : '深圳美乐创科技有限公司';
      }
      return "CAS HuaZhi (Shenzhen) Ltd.";
    },
    copyrightLabel() {
      return this.lang.indexOf('en') !== -1 ? 'All rights reserved.' : '版权所有';
    },
    supportDetails() {
      if (this.lang.indexOf('en') !== -1) {
        return [
          { label: 'Customer service', value: '4008 256 090 (Weekdays 9:00–18:00)' },
          { label: 'After-sales contact', value: 'Ms. Su' },
          { label: 'Contact number', value: '13640916090' },
          { label: 'Return address', value: 'No. 3 Changling Road, Nanlang Town, Zhongshan, Guangdong' },
          { label: 'Recipient', value: 'Tao Baowei' },
          { label: 'Recipient phone', value: '13640924455' }
        ];
      }
      return [
        { label: '全国统一客服专线', value: '4008 256 090（服务时间：工作日 9:00–18:00）' },
        { label: '售后业务联系人', value: '苏小姐' },
        { label: '联系电话', value: '13640916090' },
        { label: '售后收货地址', value: '广东省中山市南朗镇长岭路3号振威电子有限公司' },
        { label: '收货人', value: '陶保卫' },
        { label: '收货联系电话', value: '13640924455' }
      ];
    }
  },
  data() {
    return {
      showModel: false
    };
  },
  methods: {
    showSupport() {
      this.showModel = true;
    },
    closeSupport() {
      this.showModel = false;
    },
    ncloseSupport() {
      return false;
    }
  }
};
</script>

<style lang="stylus" scoped>
.site-footer-modern {
  background: #091126;
  color: #aeb9d0;
}

.footer-main {
  padding: 76px 0 50px;
}

.footer-inner {
  max-width: 1344px;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
  gap: 48px;
}

.footer-col {
  &.footer-brand {
    .footer-logo {
      height: 50px;
      width: auto;
      margin-bottom: 16px;
      opacity: 1;
    }

    .footer-desc {
      font-size: 14px;
      line-height: 1.7;
      margin: 0 0 20px 0;
      color: #8996b2;
    }

    .footer-social {
      display: flex;
      gap: 12px;
    }

    .social-link {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #b0b0c0;
      transition: all 0.3s ease;

      &:hover {
        background: #2459d5;
        color: #fff;
        transform: translateY(-2px);
      }
    }
  }
}

.footer-col-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #4b78e4;
  display: inline-block;
}

.footer-links {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    margin-bottom: 12px;
  }

  a {
    color: #98a5bf;
    text-decoration: none;
    font-size: 14px;
    transition: all 0.3s ease;
    display: inline-block;

    &:hover {
      color: #70d7ff;
      transform: translateX(4px);
    }
  }
}

.footer-contact {
  .contact-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .contact-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 14px;
    line-height: 1.5;
    color: #b9c4da;

    svg {
      flex-shrink: 0;
      margin-top: 2px;
      color: #70d7ff;
    }

    div {
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    small {
      color: #6f7d9a;
      font-size: 11px;
    }

    a,
    span {
      color: #c2cce0;
      font-size: 14px;
      line-height: 1.55;
      text-decoration: none;
      word-break: break-word;
    }

    a:hover {
      color: #70d7ff;
    }
  }
}

/* Bottom Bar */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 24px 0;
  background: rgba(2, 8, 22, 0.32);
}

.footer-bottom-inner {
  max-width: 1344px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.copyright {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 12px;
  color: #73809b;

  strong {
    color: #c4cee1;
    font-size: 13px;
    font-weight: 500;
  }
}

.footer-bottom-links {
  display: flex;
  gap: 20px;

  a {
    color: #9da9c0;
    text-decoration: none;
    font-size: 13px;
    transition: color 0.3s ease;

    &:hover {
      color: #70d7ff;
    }
  }

  .beian-link {
    padding: 7px 12px;
    border: 1px solid rgba(157, 174, 211, 0.2);
    border-radius: 999px;
  }
}

/* Modal */
.modal {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.hide {
  display: none;
}

.show {
  display: flex;
}

.modal-content {
  background-color: #fefefe;
  padding: 32px;
  border-radius: 12px;
  width: 90%;
  max-width: 520px;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #0066cc;
}

.modal-body {
  p {
    margin: 0 0 12px 0;
    font-size: 14px;
    color: #555;
    line-height: 1.6;

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      color: #333;
    }
  }
}

.close {
  position: absolute;
  top: 16px;
  right: 20px;
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  line-height: 1;
  transition: color 0.3s ease;

  &:hover,
  &:focus {
    color: #333;
    text-decoration: none;
  }
}

/* Responsive */
@media (max-width: 900px) {
  .footer-inner {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }
}

@media (max-width: 600px) {
  .footer-inner {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .footer-bottom-inner {
    flex-direction: column;
    text-align: center;
  }

  .footer-main {
    padding: 40px 0 24px;
  }
}
</style>
